import { Box, Typography } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import { bannerStyles } from "./quoteBox.style";

export const NewQuoteBanner = () => {
  const classes = bannerStyles();

  return (
    <Box className={classes.root}>
      <FiberManualRecordIcon color="secondary" className={classes.icon} />
      <Typography variant="subtitle2">New Quote</Typography>
    </Box>
  );
};
